const events: Record<string, string> = {
  BANNER_CLICKED: 'banner-clicked',
  COMPANY_PROFILE_CLICKED: 'company_profile_pressed',
  COMPANY_REVIEWS_CLICKED: 'company_reviews_pressed',
  DASHBOARD_LINK_CLICKED: 'myactivity_home_pressed',
  JOB_DETAILS_TITLE_CLICKED: 'job_details_title_pressed',
  JOB_SAVE_LOGGED_OUT_CLICKED: 'job-save-logged-out-clicked',
  MORE_JOBS_BY_COMPANY_CLICKED: 'jobs_by_company_pressed',
  QUICK_SEARCH_CLICKED: 'quick_search_pressed',
};

const map: Record<string, string> = {
  ['comm-games-banner-clicked']: events.BANNER_CLICKED,
  ['profile-banner-clicked']: events.BANNER_CLICKED,
  ['why-settle-banner-clicked']: events.BANNER_CLICKED,
  ['job-saved-logged-out']: events.JOB_SAVE_LOGGED_OUT_CLICKED,
  ['job-details-company-profile-clicked']: events.COMPANY_PROFILE_CLICKED,
  ['job-details-company-reviews-clicked']: events.COMPANY_REVIEWS_CLICKED,
  ['job-details-more-jobs-by-company-clicked']:
    events.MORE_JOBS_BY_COMPANY_CLICKED,
  ['job-details-title-clicked']: events.JOB_DETAILS_TITLE_CLICKED,
  ['dashboard-heading-saved-searches-click']: events.DASHBOARD_LINK_CLICKED,
  ['dashboard-heading-saved-jobs-click']: events.DASHBOARD_LINK_CLICKED,
  ['dashboard-heading-recommended-jobs-click']: events.DASHBOARD_LINK_CLICKED,
  ['dashboard-save-search-click']: events.DASHBOARD_LINK_CLICKED,
  ['dashboard-save-job-click']: events.DASHBOARD_LINK_CLICKED,
  ['dashboard-recommended-job-click']: events.DASHBOARD_LINK_CLICKED,
  ['dashboard-all-saved-searches-click']: events.DASHBOARD_LINK_CLICKED,
  ['dashboard-all-saved-jobs-click']: events.DASHBOARD_LINK_CLICKED,
  ['dashboard-all-recommended-jobs-click']: events.DASHBOARD_LINK_CLICKED,
  ['dashboard-save-search-jobs-profile']: events.DASHBOARD_LINK_CLICKED,
  ['dashboard-save-jobs-profile']: events.DASHBOARD_LINK_CLICKED,
  ['dashboard-recommended-jobs-profile']: events.DASHBOARD_LINK_CLICKED,
  ['quick-search-classification-priority']: events.QUICK_SEARCH_CLICKED,
  ['quick-search-classification']: events.QUICK_SEARCH_CLICKED,
  ['quick-search-city']: events.QUICK_SEARCH_CLICKED,
  ['quick-search-graduate']: events.QUICK_SEARCH_CLICKED,
  ['quick-search-employers']: events.QUICK_SEARCH_CLICKED,
  ['quick-search-recruiter']: events.QUICK_SEARCH_CLICKED,
};

type EventName = keyof typeof events;
export const mapEventName = (linkName: string = ''): EventName => map[linkName];
